import dynamic from 'next/dynamic'

export const BentoThree = dynamic(() => import('./bento-three'), { ssr: false })
